import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { settingSetGuarantor } from 'services/setting'

export default function useSetGuarantor(refetch: () => void) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISetGuarantorSettingPayload) => {
            return settingSetGuarantor(payload)
        },
        onSuccess: (data) => {
            refetch()
            toast.success('با موفقیت تغییر یافت')
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { mutate }
}
